import animate from '../utils/animate';
import whenElementsOnViewport from '../utils/whenElementsOnViewport';

export default () => {
  if (window.matchMedia('(min-width: 1200px').matches) {
    const sectionTopImages = document.querySelector('.section-top__images');

    whenElementsOnViewport([sectionTopImages], () => {
      animate(document.querySelector('.section-top__pattern'), 'fadeIn');
      animate(document.querySelector('.section-top__circle-wrapper'), 'fadeIn', 0.5);
      animate(document.querySelector('.section-top__list-wrapper'), 'fadeInLeft', 1);
      animate(document.querySelector('.section-top__firestop-wrapper'), 'fadeInRight', 1.5)
        .then(() => {
          const sectionTopParallax = new Parallax(sectionTopImages);
        });
    });
  }

  const sectionTitles = Array.from(document.querySelectorAll('.text-animate'));
  whenElementsOnViewport(sectionTitles, (current) => {

  });
};
